import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=f0131dac&scoped=true&"
import script from "./manage.vue?vue&type=script&lang=js&"
export * from "./manage.vue?vue&type=script&lang=js&"
import style1 from "./manage.vue?vue&type=style&index=1&id=f0131dac&prod&lang=less&"
import style2 from "./manage.vue?vue&type=style&index=2&id=f0131dac&prod&lang=less&"
import style3 from "./manage.vue?vue&type=style&index=3&id=f0131dac&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0131dac",
  null
  
)

export default component.exports